import { useEffect } from "react";

const useMdcSelectScrollFixAll = (): void => {
  useEffect(() => {
    const handledMenus = new WeakSet<HTMLElement>();

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        const menuNodes: HTMLElement[] = [];

        if (mutation.type === "childList") {
          mutation.addedNodes.forEach((node) => {
            if (
              node instanceof HTMLElement &&
              node.classList.contains("mdc-menu-surface")
            ) {
              menuNodes.push(node);
            }
          });
        }

        if (
          mutation.type === "attributes" &&
          mutation.target instanceof HTMLElement
        ) {
          const target = mutation.target;
          if (target.classList.contains("mdc-menu-surface--open")) {
            menuNodes.push(target);
          }
        }

        menuNodes.forEach((menu) => {
          if (handledMenus.has(menu)) return;
          handledMenus.add(menu);

          const handleTouchMove = (e: TouchEvent) => e.stopPropagation();

          menu.addEventListener("touchmove", handleTouchMove, {
            passive: false,
          });

          const innerObserver = new MutationObserver(() => {
            if (!menu.classList.contains("mdc-menu-surface--open")) {
              menu.removeEventListener("touchmove", handleTouchMove);
              innerObserver.disconnect();
              handledMenus.delete(menu);
            }
          });

          innerObserver.observe(menu, {
            attributes: true,
            attributeFilter: ["class"],
          });
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["class"],
    });

    return () => observer.disconnect();
  }, []);
};

export default useMdcSelectScrollFixAll;
